import DocumentDetails from "./DocumentDetails";
export default DocumentDetails;
